/** "Your answers": every answer the person gave, wherever they were asked, to change in place. */
import { type ReactNode, useState } from "react";
import type { WatchAnswer } from "../../../shared/types";
import { usePage } from "./context";
import { answerSource } from "./model";

function AnswerCard({ a }: { a: WatchAnswer }): ReactNode {
  const { host, data, nowMs, changeAnswer, toast } = usePage();
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState(a.answer ?? "");
  const pick = (value: string) => {
    setEditing(false);
    changeAnswer(a, value).catch(() => toast("That did not save. Try again."));
  };
  return (
    <div className="ans">
      <div className="ans-top">
        <div className="ans-x">
          <div className="ans-q">{a.question}</div>
          <div className={`ans-a${a.answer ? "" : " none"}`}>{a.answer || "Not answered yet"}</div>
          <div className="ans-src">{answerSource(a, host, data.sessions, Math.floor(nowMs / 1000))}</div>
        </div>
        {editing ? (
          <button type="button" className="btn btn-g" onClick={() => setEditing(false)}>
            Done
          </button>
        ) : (
          <button type="button" className={`btn ${a.answer ? "btn-g" : "btn-p"}`} onClick={() => setEditing(true)}>
            {a.answer ? "Change" : "Answer"}
          </button>
        )}
      </div>
      {editing ? (
        a.options.length ? (
          <div className="chips">
            {a.options.map((o) => (
              <button key={o} type="button" className={`chip${a.answer === o ? " cur" : ""}`} onClick={() => pick(o)}>
                {o}
              </button>
            ))}
          </div>
        ) : (
          <form
            className="ans-type"
            onSubmit={(e) => {
              e.preventDefault();
              if (draft.trim()) pick(draft.trim());
            }}
          >
            <input value={draft} onChange={(e) => setDraft(e.target.value)} aria-label={a.question} autoFocus />
            <button type="submit" className="btn btn-p">
              Save
            </button>
          </form>
        )
      ) : null}
    </div>
  );
}

export function AnswersPanel(): ReactNode {
  const { answers } = usePage();
  if (!answers.length) return <p className="sp-empty">Nothing here yet.</p>;
  return (
    <div className="answers">
      {answers.map((a) => (
        <AnswerCard key={a.id} a={a} />
      ))}
    </div>
  );
}
